import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const router = useNavigate();

  const handleSubmit = (event) => {
    event?.preventDefault();
    router(`/search/${searchTerm}`);
  };

  return (
    <section className="fixed top-0 w-full bg-black z-[999]">
      <nav className="paddingNav gap-[1rem] bg-black py-2 flex items-center justify-between">
        <Link to={"/"}>
          <h1 className="cursor-pointer text-red font-bold poppins lg:text-[2.5rem] md:text-[2rem] sm:text-[1.5rem] text-[1.2rem]">
            FilmJetHub
          </h1>
        </Link>
        <div className=" items-center gap-[20px] sm:flex hidden">
          <Link
            to={"/"}
            className="text-white lg:text-[18px] text-[16px] mont hover:text-red transition"
          >
            Movies
          </Link>
          <Link
            to={"/tvshows"}
            className="text-white lg:text-[18px] text-[16px] mont hover:text-red transition"
          >
            Tv Shows
          </Link>

          <section>
            <form
              onSubmit={handleSubmit}
              className="w-[400px]  relative items-center justify-center  md:flex hidden"
            >
              <input
                className="w-full h-[40px] pl-3 outline-none border border-red bg-transparent rounded-[10px] text-white text-[18px]"
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button
                type="submit"
                className="cursor-pointer absolute right-[8px]"
              >
                <img
                  src={"/search.svg"}
                  width={30}
                  height={30}
                  alt="search-icon"
                />
              </button>
            </form>
          </section>
        </div>
        <img
          src={"/search.svg"}
          width={30}
          height={30}
          alt="search-icon"
          className="cursor-pointer md:hidden flex"
          onClick={() => setSearchOpen(!searchOpen)}
        />
        <img
          src={"/menu.svg"}
          width={30}
          height={30}
          alt="search-icon"
          className="cursor-pointer sm:hidden flex"
          onClick={() => setToggleMenu(!toggleMenu)}
        />
        {/* <div className="lg:flex hidden">
          {auth?.currentUser?.photoURL ? (
            <img
              src={auth?.currentUser?.photoURL}
              width={35}
              height={35}
              alt="profile"
              className="cursor-pointer rounded-full"
              onClick={() => setUserOpen(!userOpen)}
            />
          ) : (
            <img
              src={"/profile.svg"}
              width={35}
              height={35}
              alt="profile"
              className="cursor-pointer"
              onClick={() => setUserOpen(!userOpen)}
            />
          )}
        </div> */}
        <div className="sm:flex hidden">
          <Link
            to={"/download"}
            className="text-white lg:text-[18px] text-[16px] mont hover:text-red transition"
          >
            Download Mobile App
          </Link>
        </div>
        {/* 
        <Link
          to={"/sign-in"}
          className="outline-none mont border-none py-2 sm:px-4  px-3 text-white bg-red text-[18px] font-bold rounded-[5px] hover:bg-white hover:text-black  transition sm:flex hidden"
        >
          Sign In
        </Link> */}
      </nav>

      {searchOpen && (
        <section className="sm:px-[6rem] px-[2rem] py-2 bg-gray absolute left-0 top-[50px] w-[100%] h-[60px] md:hidden block slide-bottom">
          <form
            onSubmit={handleSubmit}
            className="flex relative items-center justify-center"
          >
            <input
              className="w-full h-[40px] pl-3 outline-none border border-red bg-transparent rounded-[10px] text-white text-[18px]"
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button
              type="submit"
              className="cursor-pointer absolute right-[8px]"
            >
              <img
                src={"/search.svg"}
                width={30}
                height={30}
                alt="search-icon"
              />
            </button>
          </form>
        </section>
      )}

      {toggleMenu && (
        <div className="bg-gray rounded-[10px] w-[70%] h-[230px] absolute right-[10px] z-[9999]  flex-col items-center justify-center gap-[1rem] sm:hidden flex slide-bottom">
          <Link
            onClick={() => setToggleMenu(false)}
            to={"/"}
            className="text-white lg:text-[18px] text-[16px] mont hover:text-red transition"
          >
            Movies
          </Link>
          <Link
            onClick={() => setToggleMenu(false)}
            to={"/tvshows"}
            className="text-white lg:text-[18px] text-[16px] mont hover:text-red transition"
          >
            Tv Shows
          </Link>
          <Link
            to={"mailto:filmjethub@gmail.com"}
            className="text-white lg:text-[18px] text-[16px] mont hover:text-red transition"
          >
            Contact us
          </Link>
          <Link
            to={"/download"}
            className="text-white lg:text-[18px] text-[16px] mont hover:text-red transition"
          >
            Download Mobile App
          </Link>
          {/* <Link
            onClick={() => setToggleMenu(false)}
            to={"/sign-in"}
            className="text-white lg:text-[18px] text-[16px] mont hover:text-red transition"
          >
            Sign In
          </Link> */}
        </div>
      )}
    </section>
  );
};

export default Navbar;
